import { codeSchemaFields } from "../utils/code";
export const deleteApiTemplate = {
  name: 'delete',
  required: false,
  desc: '删除接口',
  dbMethod: 'delete',
  canBeBatched: true,
  request: {
    query: {
      title: 'url参数',
      type: 'object',
      required: false,
      fields: [{
        id: 'id',
        type: 'string',
        title: '对象id'
      }],
      useInDB: true
    },
    body: {
      title: '请求包体',
      type: 'object',
      required: false,
      fields: [{
        id: 'id',
        type: 'string',
        title: '对象id'
      }]
    }
  },
  response: {
    body: {
      title: '返回包体',
      type: 'object',
      fields: [{
        id: 'data',
        type: 'boolean',
        title: '删除操作是否成功'
      }, ...codeSchemaFields]
    }
  }
};
//# sourceMappingURL=delete.js.map
